import React, { useState } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import DataTeam from "./TeamsData"

import moment from "moment";
import UIkit from "uikit";

const columns = [
 
  {
    name: "NAME",
    selector: "name",
  },
  {
    name: "USERS",
    selector: "users",
  },
  {
    name: "DESCRIPTION",
    selector: "description",
  },
  {
    name: "Created",
    selector: "created",
  },
  {
    name: "UPDATED",
    selector: "updated",
  },
  {
    name: "",
    cell: (row) => (
      <div className="">
        <div className="uk-inline">
          <button
            className="iconTble actionDropDownBtn"
            type="button"
            uk-toggle={`target: #drop-menu-${row.id}`}
            aria-haspopup="true"
            aria-expanded="false"
          >
            <img
              src="./assets/images/zong/overflow-menu--vertical.svg"
              uk-svg=""
              alt="Menu"
            />
          </button>

          <div
            id={`drop-menu-${row.id}`}
            uk-dropdown="mode: click"
            className="actionDropDown"
          >
            <ul className="uk-nav uk-dropdown-nav mainauto">
              <li>
                <a href="#">
                  <span>
                    <img
                      src="./assets/images/zong/download.svg"
                      uk-svg=""
                      alt="Download"
                    />
                    <span>Download</span>
                  </span>
                </a>
              </li>
              <li>
                <a href="#">
                  <span className="DeletBtn">
                    <img
                      src="./assets/images/zong/trash-can.svg"
                      uk-svg=""
                      alt="Delete"
                    />
                    <span>Delete</span>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    ),
  },
];

const Teams = () => {
  const [searchText, setSearchText] = useState("");

  const handleSearch = (event) => {
    setSearchText(event.target.value);
  };

  const filteredDataTeam = DataTeam.filter((TeamData) => {
    return (
      TeamData.name.toLowerCase().includes(searchText.toLowerCase()) ||
      TeamData.users .toLowerCase().includes(searchText.toLowerCase()) ||
      TeamData.description.toLowerCase().includes(searchText.toLowerCase()) ||
      TeamData.created.toLowerCase().includes(searchText.toLowerCase()) ||
      TeamData.updated.toLowerCase().includes(searchText.toLowerCase())
    );
  });

  const handleExportData = () => {
    // console.log("Exporting data...");
    const exportedData = filteredDataTeam.map((TeamData) => ({
      SERIES: TeamData.id,
      name: TeamData.name,
      "USERS": TeamData.users ,
      "Description": TeamData.description,
      CREATED: TeamData.created,
      UPDATED: TeamData.updated,
    }));

    const csvContent =
      "data:text/csv;charset=utf-8," + convertToCSV(exportedData);
    const jsonData = JSON.stringify(exportedData, null, 2);

    const downloadLink = document.createElement("a");
    downloadLink.href = csvContent;
    downloadLink.download = "exported_data.csv";
    downloadLink.click();
  };

  const convertToCSV = (data) => {
    const header = Object.keys(data[0]).join(",");
    const rows = data.map((item) => Object.values(item).join(","));
    return [header, ...rows].join("\n");
  };

  return (
    <div className="ImcomingCallMain RoutingMain">
      <div className="uk-grid" uk-grid="">
        <div className="uk-width-1-2">
          <div className="uk-text-left">
            {/* <div className="MainHeading">
                <h6>Department</h6>
                <div className="uk-text-left">
                <div className="CustomSearch">
                  <form className="uk-search uk-search-default">
                   

                    <input
                      className="uk-search-input"
                      type="text"
                      placeholder="Search by name or number"
                      value={searchText}
                      onChange={handleSearch}
                    />
                  </form>
                </div>
              </div>
              </div> */}
          </div>
        </div>

        <div className="uk-width-1-2">
          <div className="uk-text-right">
            <span>
              <div className="uk-inline uk-text-left">
                <Link className="exportData-button NewFlow" to="/add-team">
                    Add team
                </Link>
                <button
                  className="exportData-button"
                  onClick={handleExportData}
                >
                  Export Data
                </button>
              </div>
            </span>
            <span className="primary-color"></span>
          </div>
        </div>
      </div>

      <DataTable columns={columns} data={filteredDataTeam} pagination />
    </div>
  );
};

export default Teams;
